<!-- card-1.vue -->
<script setup lang="tsx">
defineProps({
  button: {
    type: String,
    default:null // 设置默认值为 false
  }
})
const emit =defineEmits(['close'])
function gotoLink(url:string){
  location.href = url;
}
function buttonClick() {
  emit('close');
  console.log('click');
}
</script>

<template>
  <div class="card">
    <div class="content">
      <slot></slot>
    </div>
    <div class="back">
      <div class="box"></div>
      <div class="box1"></div>
    </div>
    <!-- 插入按钮，并定位在 .back 上面 -->
    <div class="rect rect1"></div>
    <div class="rect rect2"></div>
    <div class="rect rect3"></div>
    <div class="action-button" @click="buttonClick()" v-if="button">{{button}}</div>
  </div>
</template>

<style scoped lang="scss">
$card-height: 45dvh;
$card-width: 50dvh;
$box-size: 1.5dvh;
$box-height: 7dvh;
$box-padding: 33dvh;
$back-padding:10dvh;
$color1: #262626;
$color2: #303030;
$rect-width:1.5dvh;
$color3: rgba(43, 43, 43, 0);

.card {
  width: 50dvh;
  max-width: 90%;
  height: $card-height;
  min-height: $card-height;
  background-color: #2B2B2B;
  border-radius: 15px;
  position: relative;  // 确保按钮可以相对于卡片定位
}

.back {
  user-select: none;
  display: flex;
  flex-direction: column; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: stretch; // 让子元素左右占满
  margin-top: $card-height - $back-padding;
  width: 100%;
  border-radius: 15px;
  height: $box-height;
  background: $color1;
}

.box {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color2 0px,
          $color2 $box-size,
          $color3 $box-size,
          $color3 2 * $box-size
  );
}

.box1 {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color3 0px,
          $color3 $box-size,
          $color2 $box-size,
          $color2 2 * $box-size
  );
}

/* 按钮样式 */
.action-button {
  position: absolute;  // 绝对定位
  top:$card-height - $back-padding+2;  // 垂直居中
  right: 3dvh;
  cursor: pointer;
  display: flex;
  height: 6dvh;
  width: 12dvh;

  flex-direction: column; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: stretch; // 让子元素左右占满
  text-align: center;
  font-family: "wenfeng-mkzyt", sans-serif;
  border: #2B2B2B 1px solid;
  background-color: #A8C0FF;
  border-radius: 10px;
}
.rect{
  position: absolute;
  background-color: $color2;
  width: $rect-width;
  height: 3dvh;
  top:$box-padding;
}
.rect1{
  right: 9dvh;
}
.rect2{
  right: 6dvh;
}
.rect3{
  right: 3dvh;
}
.action-button-1{
  height: 6dvh;
  width: 12dvh;
  border-radius: 10px;
  background-color: #A8C0FF;
  display: flex;
  flex-direction: column; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: stretch; // 让子元素左右占满
  text-align: center;
  font-family: "wenfeng-mkzyt", sans-serif;
  border: #2B2B2B 1px solid;

}

.action-button:hover {
  background-color: #A1BCFFFF;
}

.content{
  max-width: 100%;
  width: $card-width;
  box-sizing: border-box;

  padding: 20px;
  position: absolute;
  height: $box-padding;
  overflow-y: auto;
}
</style>
